import { useFlags } from 'launchdarkly-react-client-sdk';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getUserLanguagePreferences } from 'src/modules/user/selectors/userSelectors';

// Returns whether we should be using the localized version of the app for this user.
export const useLocalizedVersion = () => {
    const { translationUi } = useFlags();
    const languagePreferences = useSelector(getUserLanguagePreferences);
    const firstLanguagePreference = languagePreferences[0];
    return useMemo(() => {
        return [Boolean(translationUi && firstLanguagePreference !== 'English')];
    }, [translationUi, firstLanguagePreference]);
};
